<template>
  <div>
    <Rank :options="responseitems" :fields="fields" :value="valueObj" @input="valueInput($event)"></Rank>
  </div>
</template>
<script>
  import responseMixin from "./responseMixin";
  import Rank from "./components/Rank";
  export default {
    components: {Rank},
    mixins: [responseMixin],
    computed:{
      responseitems() {
        return (this.responseoptions || []).map((opt) => {
          return {
            optionid: opt.value,
            content_textassetid: opt.content_textassetid,
          };
        });
      },
      fields() {
        return this.journeyanswers.map((ans) => {
          return {
            fieldid: ans.journeyanswerid,
            content_textassetid: ans.field.content_textassetid,
          }
        });
      },
      valueObj(){
        if (!this.value || !this.journeyanswers) {
          return {}
        }
        const ans = {};
        for (let id of Object.keys(this.journeyanswers)) {
          const ja = this.journeyanswers[id];
          ans[ja.journeyanswerid] = this.value.answers[ja.journeyanswerid].value
        }
        return ans;
      }
    },
    methods:{
      valueInput(obj) {
        const result = JSON.parse(JSON.stringify(this.value));
        for (let journeyanswerid of Object.keys(obj)) {
          result.answers[journeyanswerid].value = obj[journeyanswerid];
        }
        this.emitInput(result);
      }
    }
  }
</script>